import { openBlock as e, createElementBlock as t, createElementVNode as a } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ a("path", { d: "M2.53 1.47a.75.75 0 0 0-1.06 1.06l1.256 1.257a6.75 6.75 0 0 0-.293 8.028l-.809.81A.531.531 0 0 0 2 13.53h3a.531.531 0 0 0 .531-.53v-3a.531.531 0 0 0-.907-.376l-1.107 1.107a5.25 5.25 0 0 1 .279-5.876l7.348 7.349a5.25 5.25 0 0 1-2.96 1.042.75.75 0 0 0 .052 1.5 6.75 6.75 0 0 0 3.977-1.473l1.257 1.256a.75.75 0 1 0 1.06-1.06l-1.256-1.257a6.749 6.749 0 0 0 .294-8.029l.808-.808A.531.531 0 0 0 14 2.469h-3a.531.531 0 0 0-.531.531v3a.531.531 0 0 0 .907.376l1.107-1.108a5.25 5.25 0 0 1-.278 5.876L4.856 3.796a5.25 5.25 0 0 1 2.34-.984.75.75 0 0 0-.229-1.482 6.75 6.75 0 0 0-3.18 1.396L2.53 1.47Z" }, null, -1), n = [
  l
];
function c(r, s) {
  return e(), t("svg", o, [...n]);
}
const d = { render: c };
export {
  d as default,
  c as render
};
